
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","data-token-name":"write-document"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.11 9.865a1.533 1.533 0 012.14-.061 1.533 1.533 0 01-.061 2.14c-.588.589-3.168 1.088-3.168 1.088s.5-2.58 1.088-3.167zm2.377-5.152l2.426-2.426a.98.98 0 011.386 0l.693.693","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.447 8.52l5.545-5.544a1.474 1.474 0 012.08 0v0a1.475 1.475 0 010 2.08L10.525 10.6l-2.08-2.08zm3.466-3.457l2.079 2.079","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.146 10.001c0 2.694.284 4.217-1.172 5.672l-.754.754a.252.252 0 01-.178.073H1.75a.25.25 0 01-.177-.427l.4-.4c1.51-1.51 1.173-2.476 1.173-10.516 0-2.098 1.566-3.222 2-3.657h2.966","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    